import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

export const makeStore = <Type>(reducers: any, preloadedState?: Partial<Type>) => {
	const store = configureStore({
		reducer: reducers,
		middleware: (getDefaultMiddleware) => {
			return getDefaultMiddleware()
		},
		preloadedState,
	})

	setupListeners(store.dispatch)
	return store
}
